import { Component, input } from '@angular/core';

import { ShootingStar, SpaceParticle } from '../landing.types';

@Component({
    selector: 'app-landing-starfield',
    standalone: true,
    templateUrl: './landing-starfield.component.html',
    styleUrl: './landing-starfield.component.scss'
})
export class LandingStarfield {
    readonly particles = input.required<SpaceParticle[]>();
    readonly stars = input.required<ShootingStar[]>();
}
